import {AfterViewInit, Component, Input, OnDestroy, ViewChild} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {NgForm} from '@angular/forms';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AuthService} from '../../../shared/services/auth.service';
import {
  DEREGISTRATION_PACK_STATUS_SENT,
  DICT_TYPE_TEMPLATE_TYPE,
  DictService,
  EXAM_TYPE_100P,
  INSURANCE_TYPE_ASSETS,
  INSURANCE_TYPE_LIFE,
  REGISTRATION_STATUS_EXAM_PASSED,
  REGISTRATION_STATUS_SENT_TO_REGISTER_IN_INSURANCE_COMPANY,
  REGISTRATION_STATUS_SIGNED_UP_FOR_AN_EXAM, REGISTRATION_STATUS_TO_DEREGISTER, REPORT_TYPE_REGISTRATION,
  TEMPLATE_TYPE_AUTHORIZATION
} from '../../../shared/services/dict.service';
import {delay, distinctUntilChanged, first, takeUntil, tap} from 'rxjs/operators';
import {CountedAndPaginated} from '../../../shared/interface/response/counted-and-paginated';
import {RegistrationService} from '../../../shared/services/registration.service';
import {Registration} from '../../../shared/interface/registration';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {ActivatedRoute, Router} from '@angular/router';
import {DeregistrationPack} from '../../../shared/interface/deregistration-pack';
import {DeregistrationPackService} from '../../../shared/services/deregistration-pack.service';
import {AddRegistrationComponent} from '../../deregistration-pack/add-registration/add-registration.component';
import {HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {TemplateService} from '../../../shared/services/template.service';
import {DownloaderService} from '../../../shared/services/downloader.service';
import {ExamSelectDialogComponent} from '../../meetings/exam-select-dialog/exam-select-dialog.component';
import {Meeting} from '../../../shared/interface/meeting';
import {MeetingService} from '../../../shared/services/meeting.service';
import {Uuid} from '../../../shared/interface/response/uuid';
import {JobResultDialogComponent} from '../../../shared/components/job-result-dialog/job-result-dialog.component';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';
import {InsuranceCompany} from '../../../shared/interface/insurance-company';
import {select, Store} from '@ngrx/store';
import {StoreRootState} from '../../../shared/ngrx/reducers';
import {getCurrentRouteState} from '../../../shared/ngrx/selector';
import {RouterStateUrl} from '../../../shared/ngrx/route-serializer';
import {FilterService} from '../../../shared/services/filter.service';
import {ReportCustomComponent} from "../../report-custom/report-custom.component";
import {Sort} from "@angular/material/sort";
import {SelectionModel} from "@angular/cdk/collections";
import {RegistrationIdImport} from "../../../shared/interface/registration-id-import";
import {co} from "@fullcalendar/core/internal-common";
import {IddTraining} from "../../../shared/interface/idd-training";
import {
  IC_AWP,
  IC_DEFEND,
  IC_COMPENSA_LIFE,
  IC_EUROP_ASSISTANCE,
  IC_EUROPA,
  IC_EUROINS,
  IC_TUZ_UBEZPIECZENIA,
  IC_UNIQA_INTERRISK,
  IC_LINK4,
  IC_POCZTOWE_TUW,
  IC_COLONNADE,
  IC_PZU,
  IC_TRASTI,
  IC_INTER_POLSKA,
  IC_METLIFE,
  IC_OPEN_LIFE,
  IC_PZU_LIFE,
  IC_UNUM_LIFE,
  IC_PRU,
  IC_PREVOIR,
  IC_INTER_POLSKA_LIFE,
} from "../../../shared/services/insurance-company.service";

@Component({
  selector: 'app-all-registrations-list',
  templateUrl: './all-registrations-list.component.html',
  styleUrls: ['./all-registrations-list.component.scss']
})
export class AllRegistrationsListComponent implements AfterViewInit, OnDestroy {
  @Input() filterPending = false;
  @Input() reloadList?: ReplaySubject<any>;
  @Input() deregistrationPackObject?: DeregistrationPack;
  @Input() showAddToPackAction = null;
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild('paginator') paginator: MatPaginator;
  @Input() contractId?: string = null;
  @Input() ofwcaId?: string = null;
  @Input() partnerId?: string = null;
  @Input() insuranceCompanyId?: number = null;
  @Input() hasDiploma?: number = null;
  @Input() statements?: number = null;
  @Input() activeKrk?: number = null;
  @Input() statusKeys?: string[] = null;
  @Input() iddTrainingObject?: IddTraining;
  @Input() registrationIdConsentToDualRegistration?: number = null;
  @Input() agreedToDeregister?: boolean = null;
  @Input() activeContract?: number = null;
  @Input() canSignUpForAnExam?: number = null;
  @Input() deregistrationPack?: string = null;
  @Input() authorizationStatusKey?: string = null;
  @Input() disableFilters = null;
  @Input() disableBreadcrumb = null;
  @Input() excludeColumns: string[] = null;
  @Input() reportConsents = null;
  @Input() onlyChronie = null;
  @Input() blockedView = null;
  @Input() newChronieAccess = null;
  @Input() revokedChronieAccess = null;
  @Input() blocked = null;
  @Input() embeddedView = false;
  @Input() displayColumns = null;
  @Input() showTotalCount = false;
  @Input() passedExam100p?: number = null;
  @Input() registrationFacilityAddressPzu?: number = null;
  @Input() companyId?: number = null;
  @Input() haveDeregistrationPack: boolean = false;
  @Input() deregistrationPackUuid?: string = null;
  @Input() registrationIdTypeSent: boolean = null;
  @Input() customBreadcrumb =  null;
  @Input() hiperioTestAccess =  null;
  protocolOpened = false;
  selection = new SelectionModel<Registration>(true, []);
  initialFilters: any;
  ToBeBlocked = false;
  registrations: Registration[] = [];
  displayedColumns: string[] = ['name', 'ofwca', 'ofwcaLastName', 'ofwca_just', 'insuranceCompany_just',
    'insuranceCompany', 'insuranceCompanyType', 'status', 'passedExam100p', 'statements', 'activeKrk',
    'signedUpForAnExam', 'examPassed', 'passedExam40p', 'sentToRegister', 'agreedToDeregister', 'deregistrationPack',
    'missingExam', 'company', 'partner', 'assetsRegional', 'chronieLogin',
    'chronieDiscountCode',  'rauNumber', 'rauNumberError', 'sentToBlock', 'blocked', 'chronieAccess',
    'trainingRequirement', 'requirementMet', 'actions'];
  totalData = 0;
  updateInProgress = false;
  sortBy = 'ofwcaLastName';
  sortOrder = 'desc';
  serchRegistration = true;

  readonly DEREGISTRATION_PACK_STATUS_SENT = DEREGISTRATION_PACK_STATUS_SENT;
  readonly REGISTRATION_STATUS_TO_DEREGISTER = REGISTRATION_STATUS_TO_DEREGISTER;
  readonly SIGNED_UP_FOR_AN_EXAM = [
    REGISTRATION_STATUS_SIGNED_UP_FOR_AN_EXAM,
    REGISTRATION_STATUS_EXAM_PASSED,
    REGISTRATION_STATUS_SENT_TO_REGISTER_IN_INSURANCE_COMPANY
  ];
  readonly EXAM_PASSED = [
    REGISTRATION_STATUS_EXAM_PASSED,
    REGISTRATION_STATUS_SENT_TO_REGISTER_IN_INSURANCE_COMPANY
  ];
  readonly SENT_TO_REGISTER = [
    REGISTRATION_STATUS_SENT_TO_REGISTER_IN_INSURANCE_COMPANY
  ];
  readonly INSURANCE_TYPE_LIFE = INSURANCE_TYPE_LIFE;
  readonly INSURANCE_TYPE_ASSETS = INSURANCE_TYPE_ASSETS;

  selectedInsuranceCompanies?: InsuranceCompany[];
  userPermissions: ReplaySubject<UserPermissions>;
  private generatingDocument = false;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private registrationService: RegistrationService,
    private deregistrationPackService: DeregistrationPackService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private dictService: DictService,
    private activatedRoute: ActivatedRoute,
    private templateService: TemplateService,
    private downloader: DownloaderService,
    private meetingService: MeetingService,
    private store: Store<StoreRootState>,
    private router: Router,
    private filterService: FilterService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.registrationService.getRegistrationListSubject()
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<Registration>) => {
          this.registrations = e.items.map(reg => {
            const icKey = reg.insuranceCompany?.key;
            reg.requirementMet = this.checkIddRequirementMet(this.iddTrainingObject, icKey);
            return reg;
          });
          this.totalData = e.pagination.total;
          this.updateInProgress = false;
          this.serchRegistration = false;
        })
      ).subscribe();
    this.parseFilters();
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      ofwca: 'string',
      contract: 'string',
      in$insuranceCompany: 'int[]',
      salesProfileType: 'int',
      insuranceCompanyType: 'int',
      in$status: 'int[]',
      salesProfileStatus: 'int',
      statements: 'int',
      company: 'int',
      partner: 'string',
      assetsRegional: 'string[]',
      lifeRegional: 'string[]',
      doubleRegistration: 'int',
      missingExam: 'int',
      activeKrk: 'int',
      passedExam100p: 'int',
      hasDiploma: 'int',
      agreedToDeregister: 'int',
      partnerTags: 'int[]',
      authorizationStatus: 'int',
      gte$authorizationGeneratedAt: 'date',
      lte$authorizationGeneratedAt: 'date',
      gte$createdAt: 'date',
      lte$createdAt: 'date',
      chronieAccess: 'int',
      chronieLogin: 'string',
      chronieDiscountCode: 'string',
      sentToBlock: 'int',
      blocked: 'int',
      agreedToRegisterInPzu: 'int',
      rauNumber: 'string',
      deregistrationPack: 'string',
      facilityStateOfwca: 'int',
      registrationFacilityAddressPzu: 'int',
      sentToPzuForVerification: 'int',
      pzuVerificationSupplement: 'int',
      registrationIdTypeSent: 'int',
      registrationIdTypeSentDate: 'date',
      registrationIdRequestForDeletionSent: 'int',
      registrationIdRequestForDeletionSentDate: 'date',
      registrationIdConsentToDualRegistration: 'int',
      registrationIdConsentToDualRegistrationDate: 'date',
      entryKnf: 'int',
      haveDeregistrationPack: 'int',
    }, filters);
  }

  ngAfterViewInit(): void {
    this.activatedRoute.data
      .pipe(
        delay(0),
        first()
      )
      .subscribe((data: any) => {
        this.contractId = this.contractId ?? data.contractId ?? null;
        this.ofwcaId = this.ofwcaId ?? data.ofwcaId ?? null;
        this.partnerId = this.partnerId ?? data.partnerId ?? null;
        this.insuranceCompanyId = this.insuranceCompanyId ?? data.insuranceCompanyId ?? null;
        this.statements = this.statements ?? data.statements ?? null;
        this.hasDiploma = this.hasDiploma ?? data.hasDiploma ?? null;
        this.activeKrk = this.activeKrk ?? data.activeKrk ?? null;
        this.statusKeys = this.statusKeys ?? data.statusKeys ?? null;
        this.registrationIdConsentToDualRegistration = this.registrationIdConsentToDualRegistration ??
          data.registrationIdConsentToDualRegistration ?? null;
        this.registrationIdTypeSent = this.registrationIdTypeSent ??
          data.registrationIdTypeSent ?? null;
        this.agreedToDeregister = this.agreedToDeregister ?? data.agreedToDeregister ?? null;
        this.activeContract = this.activeContract ?? data.activeContract ?? null;
        this.excludeColumns = this.excludeColumns ?? data.excludeColumns ?? [];
        this.displayColumns = this.displayColumns ?? data.displayColumns ?? null;
        this.canSignUpForAnExam = this.canSignUpForAnExam ?? data.canSignUpForAnExam ?? null;
        this.deregistrationPack = this.deregistrationPack ?? data.deregistrationPack ?? null;
        this.showAddToPackAction = this.showAddToPackAction ?? data.showAddToPackAction ?? false;
        this.authorizationStatusKey = this.authorizationStatusKey ?? data.authorizationStatusKey ?? null;
        this.reportConsents = this.reportConsents ?? data.reportConsents ?? false;
        this.onlyChronie = this.onlyChronie ?? data.onlyChronie ?? null;
        this.newChronieAccess = this.newChronieAccess ?? data.newChronieAccess ?? null;
        this.revokedChronieAccess = this.revokedChronieAccess ?? data.revokedChronieAccess ?? null;
        this.blockedView = this.blockedView ?? data.blockedView ?? null;
        this.blocked = this.blocked ?? data.blocked ?? null;
        this.passedExam100p = this.passedExam100p ?? data.passedExam100p ?? null;
        this.registrationFacilityAddressPzu = this.registrationFacilityAddressPzu ?? data.registrationFacilityAddressPzu ?? null;
        this.companyId = this.companyId ?? data.companyId ?? null;
        this.haveDeregistrationPack = this.haveDeregistrationPack ?? data.haveDeregistrationPack ?? null;
        this.deregistrationPackUuid = this.deregistrationPackUuid ?? data.deregistrationPackUuid ?? null;
        this.disableFilters = this.disableFilters ?? data.disableFilters ?? false;
        this.disableBreadcrumb =  this.disableBreadcrumb ?? data.disableBreadcrumb ?? false;
        this.hiperioTestAccess = this.hiperioTestAccess ?? data.hiperioTestAccess ?? null;
        this.customBreadcrumb = this.customBreadcrumb ?? data.customBreadcrumb ?? false;

        if (!this.onlyChronie) {
          this.excludeColumns.push('chronieAccess');
          this.excludeColumns.push('rauNumber');
          this.excludeColumns.push('rauNumberError');
          this.excludeColumns.push('chronieLogin');
          this.excludeColumns.push('chronieDiscountCode');
        }

        if (!this.blockedView) {
          this.excludeColumns.push('sentToBlock');
          this.excludeColumns.push('blocked');
        }

        if (this.displayColumns !== null) {
          this.displayedColumns = this.displayColumns;
        } else {
          this.displayedColumns = this.displayedColumns.filter((e: string) => this.excludeColumns.indexOf(e) === -1);
        }

        if (!this.embeddedView) {
          this.store
            .pipe(
              select(getCurrentRouteState),
              delay(0),
              distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
              takeUntil(this.destroyed$),
            )
            .subscribe((state: RouterStateUrl) => {
              this.parseFilters(state.params);
              this.paginator.pageIndex = state.params.page;
              this.paginator.pageSize = state.params.pageSize;
              this.sortBy = state.params?.sortBy ? state.params.sortBy : 'ofwcaLastName';
              this.sortOrder = state.params?.sortOrder ? state.params.sortOrder : 'desc';
              this.loadListData();
            })
          ;
        } else {
          this.loadListData();
        }
      });

    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.serchRegistration = true;
      if (this.embeddedView) {
          this.loadListData();
        } else {
          this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
            sortBy: this.sortBy,
            sortOrder: this.sortOrder,
            page: event.pageIndex,
            pageSize: event.pageSize,
            ...this.filtersForm.value
          })]);
        }
    });

    if (this.reloadList) {
      this.reloadList
        .pipe(takeUntil(this.destroyed$))
        .subscribe(() => this.loadListData());
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  async loadListData(): Promise<void> {
    this.serchRegistration = true;
    this.registrationService.loadList(this.paginator.pageIndex,
      this.paginator.pageSize,
      this.buildFilters(),
      {
      sortBy: this.sortBy,
      sortOrder: this.sortOrder
    });
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    if (null !== this.insuranceCompanyId) {
      filters.insuranceCompany = this.insuranceCompanyId;
    }
    if (null !== this.ofwcaId) {
      filters.ofwca = this.ofwcaId;
    }
    if (null !== this.partnerId) {
      filters.partner = this.partnerId;
    }
    if (null !== this.contractId) {
      filters.contract = this.contractId;
    }
    if (null !== this.hasDiploma) {
      filters.hasDiploma = this.hasDiploma;
    }
    if (null !== this.statements) {
      filters.statements = this.statements;
    }
    if (null !== this.statusKeys) {
      filters.statusKeys = this.statusKeys;
    }
    if (null !== this.activeKrk) {
      filters.activeKrk = this.activeKrk;
    }
    if (null !== this.agreedToDeregister) {
      filters.agreedToDeregister = this.agreedToDeregister;
    }
    if (null !== this.activeContract) {
      filters.activeContract = this.activeContract;
    }
    if (null !== this.canSignUpForAnExam) {
      filters.canSignUpForAnExam = this.canSignUpForAnExam;
    }
    if (null !== this.deregistrationPack) {
      filters.deregistrationPack = this.deregistrationPack;
    }
    if (null !== this.authorizationStatusKey) {
      filters.authorizationStatusKey = this.authorizationStatusKey;
    }
    if (null !== this.onlyChronie) {
      filters.onlyChronie = this.onlyChronie;
    }
    if (null !== this.newChronieAccess) {
      filters.newChronieAccess = this.newChronieAccess;
    }
    if (null !== this.revokedChronieAccess) {
      filters.revokedChronieAccess = this.revokedChronieAccess;
    }
    if (null !== this.blocked) {
      filters.blocked = this.blocked;
    }
    if (null !== this.passedExam100p){
      filters.passedExam100p = this.passedExam100p;
    }
    if (null !== this.registrationFacilityAddressPzu){
      filters.registrationFacilityAddressPzu = this.registrationFacilityAddressPzu;
    }
    if (null !== this.companyId) {
      filters.company = this.companyId;
    }
    if (null !== this.haveDeregistrationPack){
      filters.haveDeregistrationPack = this.haveDeregistrationPack;
    }
    if (null !== this.registrationIdConsentToDualRegistration){
      filters.registrationIdConsentToDualRegistration = this.registrationIdConsentToDualRegistration;
    }
    if (null !== this.registrationIdTypeSent){
      filters.registrationIdTypeSent = this.registrationIdTypeSent;
    }
    if (null !== this.hiperioTestAccess){
      filters.hiperioTestAccess = this.hiperioTestAccess;
    }

    return filters;
  }

  filter(): void {
    if (this.serchRegistration) {
      return;
    }
    if (this.embeddedView) {
      if (this.paginator.pageIndex === 0) {
        this.loadListData();
      } else {
        this.paginator.firstPage();
      }
    } else {
      if (this.paginator.pageIndex === 0) {
        this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
          page: this.paginator.pageIndex,
          pageSize: this.paginator.pageSize,
          ...this.filtersForm.value
        })]);
      } else {
        this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
          page: 0,
          pageSize: this.paginator.pageSize,
          ...this.filtersForm.value,
        })]);
      }
    }
  }
  floor(num: number): number {
    return Math.floor(num);
  }

  downloadReport(): void {
    if (this.onlyChronie) {
      this.registrationService.downloadChronieReport(this.buildFilters())
        .subscribe((response: Uuid) => {
          const dialogRef = this.dialog.open(JobResultDialogComponent, {
            disableClose: true,
            width: '500px',
            data: {jobId: response.uuid, showProgress: false},
          });
        }, (error: HttpErrorResponse) => {
          this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
        });
    } else {
      if (this.examStatus()){
        this.registrationService.downloadReportExamStatus(this.buildFilters(), this.reportConsents, {
          sortBy: this.sortBy,
          sortOrder: this.sortOrder
        })
          .subscribe((response: Uuid) => {
            const dialogRef = this.dialog.open(JobResultDialogComponent, {
              disableClose: true,
              width: '500px',
              data: {jobId: response.uuid, showProgress: false},
            });
          }, (error: HttpErrorResponse) => {
            this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
          });
      }else {
        this.registrationService.downloadReport(this.buildFilters(), this.reportConsents, {
          sortBy: this.sortBy,
          sortOrder: this.sortOrder
        })
          .subscribe((response: Uuid) => {
            const dialogRef = this.dialog.open(JobResultDialogComponent, {
              disableClose: true,
              width: '500px',
              data: {jobId: response.uuid, showProgress: false},
            });
          }, (error: HttpErrorResponse) => {
            this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
          });
      }
    }
  }

  downloadReportToBeBlocked(): void {
      this.registrationService.downloadReportToBeBlocked(this.buildFilters(), this.reportConsents)
        .subscribe((response: Uuid) => {
          const dialogRef = this.dialog.open(JobResultDialogComponent, {
            disableClose: true,
            width: '500px',
            data: {jobId: response.uuid, showProgress: false},
          });
        }, (error: HttpErrorResponse) => {
          this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
        });
  }

downloadPzuForm(): void {
  this.registrationService.downloadPzuFormReport(this.buildFilters(), this.reportConsents, {
    sortBy: this.sortBy,
    sortOrder: this.sortOrder
  })
    .subscribe((response: Uuid) => {
      const dialogRef = this.dialog.open(JobResultDialogComponent, {
        disableClose: true,
        width: '500px',
        data: {jobId: response.uuid, showProgress: false},
      });
    }, (error: HttpErrorResponse) => {
      this.snack.open('Przy generowaniu formatki wystąpił błąd', error.status.toString(), {duration: 2000});
    });
}

  resetFilters(): void {
    this.filtersForm.resetForm();
    if (this.embeddedView) {
      this.loadListData();
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
        sortBy: this.sortBy,
        sortOrder: this.sortOrder,
        page: 0,
        pageSize: this.paginator.pageSize,
      }]);
    }
  }

  deleteRegistration(registration: Registration): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć rejestrację?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.registrationService.deleteRegistration(registration.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto rejestrację', '', {duration: 2000});
            this.loadListData();
          });
      }
    });
  }

  deleteFromDeregistrationPack(registration: Registration): void {
    this.deregistrationPackService.removeRegistrationFromPack(registration.uuid, this.deregistrationPackObject.uuid)
      .subscribe(() => {
        this.snack.open('Usunięto rejestrację z paczki', '', {duration: 2000});
        this.loadListData();
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy usuwaniu z paczki wystąpił błąd', '', {duration: 2000});

        if (error.status === 400) {
          this.snack.open(error.error.error.text, error.status.toString(), {
            duration: 3000,
          });
        }
      });
  }

  addToDeregistrationPack(registration: Registration): void {
    const dialogRef = this.dialog.open(AddRegistrationComponent, {
      width: '50%',
      data: {registrationObject: registration},
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadListData();
    });
  }

  generateAuthorization(registration: Registration): void {
    this.generatingDocument = true;
    this.dictService.getId(TEMPLATE_TYPE_AUTHORIZATION, DICT_TYPE_TEMPLATE_TYPE)
      .subscribe((dictId: number) => {
        this.templateService.generateAuthorization({
          type: dictId,
          registration: registration.uuid,
        }).subscribe({
          next: (response: HttpResponse<any>) => {
            this.downloader.downloadFile(response);
            this.generatingDocument = false;
          },
          error: (error: HttpErrorResponse) => {
            this.generatingDocument = false;
            if (error.status === 404) {
              this.snack.open('Brak szablonów dla tego typu dokumentu', '', {duration: 2000});
              return;
            }

            this.snack.open('Przy generowaniu dokumentów wystąpił błąd', error.status.toString(), {duration: 2000});
          }
        });
      });
  }

  registerToExam(registration: Registration): void {
    this.registrationService.canRegisterToExam(registration.uuid)
      .subscribe((result) => {
        if (result) {
          const dialogRef = this.dialog.open(ExamSelectDialogComponent, {
            width: '80vw',
            maxHeight: '90vh',
            autoFocus: false,
            data: {
              insuranceCompanyId: registration.missingExam.key === EXAM_TYPE_100P ? null : registration.insuranceCompany.id,
            }
          });

          dialogRef.afterClosed().subscribe((meeting: Meeting) => {
            if (meeting) {
              this.meetingService.registerToMeeting(meeting.uuid, [registration.ofwca.uuid])
                .subscribe(() => {
                  this.snack.open('OFWCA została zapisana na egzamin', '', {duration: 2000});
                  this.loadListData();
                }, (error: HttpErrorResponse) => {
                  this.snack.open('Przy zapisywaniu na egzamin wystąpił błąd', error.status.toString(), {duration: 2000});
                });
            }
          });
        } else {
          this.snack.open('Nie można zapisać na egzamin - rejestracja nie spełnia wymagań', '', {duration: 2000});
        }
      });
  }

  agreedToDeregisterChanged($event: MatSlideToggleChange, registration: Registration): void {
    this.updateInProgress = true;

    this.registrationService.updateAgreedToDeregister(registration.uuid, {
      agreedToDeregister: $event.checked
    })
      .subscribe(() => {
        this.snack.open('Pomyślnie zakutalizowano rejestrację', '', {duration: 2000});
        this.updateInProgress = false;
        registration.agreedToDeregister = $event.checked;
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy aktualizacji wystąpił błąd', error.status.toString(), {duration: 2000});
        this.updateInProgress = false;
      });
  }

  pzuChanged(
    $event: MatSlideToggleChange,
    registration: Registration,
    formData: { sentToPzuForVerification: boolean; pzuVerificationSupplement: boolean; agreedToRegisterInPzu: boolean}
  ): void {
    this.updateInProgress = true;
    this.registrationService.updatePzuRegistration(registration.uuid, formData)
      .subscribe(() => {
        this.snack.open('Pomyślnie zakutalizowano załącznik', '', {duration: 2000});
        this.loadListData();
        this.updateInProgress = false;
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy aktualizacji wystąpił błąd', error.status.toString(), {duration: 2000});
        this.updateInProgress = false;
      });
  }
  toBeBlocked(): boolean{
    if ( window.location.href.includes('rejestracje/do-zablokowani')){
      return  true;
    }
    return  false;
  }
  examStatus(): boolean{
    if ( window.location.href.includes('rejestracje/status-egzaminow')){
      return  true;
    }
    return  false;
  }
  generalList(): boolean{
    if (! window.location.href.includes('rejestracje/')){
      return  true;
    }
    return  false;
  }
  customeRaportList(): boolean{
    if (window.location.href.includes('podwojna-rejestracje') ){
      return  true;
    }
    return  false;
  }
  formChanged(
    $event: MatSlideToggleChange,
    registration: Registration,
    formData: { blocked: boolean; sentToBlock: boolean }
  ): void {
    this.updateInProgress = true;

    this.registrationService.updateBlockedRegistration(registration.uuid, formData)
      .subscribe(() => {
        this.snack.open('Pomyślnie zakutalizowano załącznik', '', {duration: 2000});
        registration.sentToBlock = formData.sentToBlock;
        registration.blocked = formData.blocked;
        this.loadListData();
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy aktualizacji wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }
  openReportDialog(): void {
    const dialogRef = this.dialog.open(ReportCustomComponent, {
      width: '70%',
      data: {filter: this.buildFilters(),
        reportName: REPORT_TYPE_REGISTRATION,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder},
    });
  }

  sortChanged($event: Sort): void {
    this.sortBy = $event.active;
    this.sortOrder = $event.direction;

    this.loadListData();

  }

  downloadDoubleRegistrationReport(): void{
    this.registrationService.downloadDoubleRegistrationReport(this.buildFilters(), {
      sortBy: this.sortBy,
      sortOrder: this.sortOrder
    })
      .subscribe((response: Uuid) => {
        const dialogRef = this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  downloadPZuRegistrationReport(): void{
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy zaznaczyłeś odpowiednie filtry do pobrania tego raportu? '},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.registrationService.downloadPzuRegistrationReport(this.buildFilters(), {
          sortBy: this.sortBy,
          sortOrder: this.sortOrder
        })
          .subscribe((response: Uuid) => {
            const dialogRef = this.dialog.open(JobResultDialogComponent, {
              disableClose: true,
              width: '500px',
              data: {jobId: response.uuid, showProgress: false},
            });
          }, (error: HttpErrorResponse) => {
            this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
          });
      }
    });

  }


  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.registrations.length;
    return numSelected === numRows;
  }
  isSelect(row?: string): boolean {
    let max = false;
    this.selection.selected.forEach((registration: Registration) => {
      if (row === registration.uuid){
        max = true;
      }
    });
    return max;
  }
  toggleAllRows(): void {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.registrations);
  }
  checkboxLabel(row?: Registration): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.uuid}`;
  }

  addRegistrationToPack(): void {
      if (this.selection.selected.length > 0) {

      this.selection.selected.forEach((registration: Registration) => {
        this.deregistrationPackService.addRegistrationToPack(registration.uuid, this.deregistrationPackUuid    )
          .subscribe(() => {
            this.loadListData();
            this.snack.open('Dodano rejestracji do paczki', '', {duration: 2000});
          });
          }, (error: HttpErrorResponse) => {
            this.snack.open('Przy dodawaniu rejestracji do paczki wystąpił błąd', error.status.toString(), {duration: 2000});
            if (error.status === 400) {
              this.snack.open(error.error.error.text, '400', {duration: 4000});
            }
          });
    } else {
      this.snack.open('Nie wybrano rejestracji','',{duration: 2000} );
    }
    this.selection.clear();
  }

  downloadVerificationReport(): void {
    this.registrationService.downloadVerificationReport(this.buildFilters())
      .subscribe((response: Uuid) => {
        const dialogRef = this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
        }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  checkIddRequirementMet(iddTraining: IddTraining, insuranceCompanyKey: string): boolean {
    if (!iddTraining || !insuranceCompanyKey) {
      return false;
    }

    if (insuranceCompanyKey === IC_AWP) {
      return true;
    }

    let requiredAssets = 0;
    let requiredLife = 0;
    let requiredGeneral = 0;
    let requiredOnlyAssets = 0;
    let requiredOnlyLife = 0;

    if (
      insuranceCompanyKey === IC_DEFEND ||
      insuranceCompanyKey === IC_EUROP_ASSISTANCE
    ) {
      requiredAssets = 900;

    } else if (
      insuranceCompanyKey === IC_EUROPA ||
      insuranceCompanyKey === IC_EUROINS ||
      insuranceCompanyKey === IC_TUZ_UBEZPIECZENIA ||
      insuranceCompanyKey === IC_UNIQA_INTERRISK ||
      insuranceCompanyKey === IC_LINK4
    ) {
      requiredAssets = 450;
      requiredGeneral = 450;

    } else if (
      insuranceCompanyKey === IC_POCZTOWE_TUW ||
      insuranceCompanyKey === IC_COLONNADE ||
      insuranceCompanyKey === IC_PZU ||
      insuranceCompanyKey === IC_TRASTI
    ) {
      requiredGeneral = 900;
      requiredOnlyAssets = 60;

    } else if (
      insuranceCompanyKey === IC_METLIFE ||
      insuranceCompanyKey === IC_OPEN_LIFE ||
      insuranceCompanyKey === IC_PZU_LIFE ||
      insuranceCompanyKey === IC_UNUM_LIFE ||
      insuranceCompanyKey === IC_PRU
    ) {
      requiredGeneral = 900;
      requiredOnlyLife = 60;

    } else if (insuranceCompanyKey === IC_PREVOIR) {
      requiredGeneral = 900;
      requiredOnlyLife = 120;

    } else if (insuranceCompanyKey === IC_INTER_POLSKA_LIFE) {
      requiredGeneral = 900;
      requiredOnlyLife = 300;

    }
    else if (insuranceCompanyKey === IC_COMPENSA_LIFE) {
      requiredGeneral = 840;
      requiredOnlyLife = 60;

    } else {
      requiredGeneral = 900;
    }

    const realisedAssets = iddTraining.realisedAssetsMinutes + iddTraining.realisedGeneralMinutes;
    const realisedLife = iddTraining.realisedLifeMinutes + iddTraining.realisedGeneralMinutes;
    const realisedGeneral = iddTraining.realisedGeneralMinutes +
      iddTraining.realisedAssetsMinutes +
      iddTraining.realisedLifeMinutes;

    const assetsCompleted = realisedAssets >= requiredAssets;
    const lifeCompleted = realisedLife >= requiredLife;
    const generalCompleted = realisedGeneral >= requiredGeneral;
    const onlyAssetsCompleted = iddTraining.realisedAssetsMinutes >= requiredOnlyAssets;
    const onlyLifeCompleted = iddTraining.realisedLifeMinutes >= requiredOnlyLife;

    return assetsCompleted && lifeCompleted && generalCompleted && onlyAssetsCompleted && onlyLifeCompleted;
  }
}
